import { render, staticRenderFns } from "./EnquiryTable.vue?vue&type=template&id=fe053d06&scoped=true"
import script from "./EnquiryTable.vue?vue&type=script&lang=js"
export * from "./EnquiryTable.vue?vue&type=script&lang=js"
import style0 from "./EnquiryTable.vue?vue&type=style&index=0&id=fe053d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe053d06",
  null
  
)

export default component.exports